import React, { useEffect, useRef, useState } from "react";
import { createContext } from "react";
import { VARIABLES } from "../Constant";
import axios from "axios";
import swal from "sweetalert";
import Swal from "sweetalert2";
import secureLocalStorage from "react-secure-storage";

export const StateContext = createContext(null);

function StateContextProvider({ children }) {
  const scheduler_id = secureLocalStorage.getItem("scheduler_id");
  console.log(scheduler_id);
  const scheduler_node_id = secureLocalStorage.getItem("scheduler_node_id");
  console.log(scheduler_node_id);
  // Scheduler Data stores as per the primary key. (Pump Scheduler Data).
  const [schedulerData, setSchedularData] = useState([]);
  console.log(schedulerData);
  ///////////////////////////

  const [tankHandleDetails, setTankHandleDetails] = useState([]);
  console.log(tankHandleDetails);

  const [lastScheduleIndex, setLastScheduleIndex] = useState(null);
  console.log(lastScheduleIndex);
  const lastScheduleIndexRef = useRef(lastScheduleIndex);

  // For particular node scheduler data handle
  // local scheduler data handle - to set local data only without api call after create/edit scheduler
  const [nodeSchedulerData, setNodeSchedulerData] = useState([]);
  console.log(nodeSchedulerData);
  const nodeSchedulerDataRef = useRef([]);

  const filterByLocalUpdateData = nodeSchedulerDataRef.current.filter((item) =>
    ["insert", "update", "delete"].includes(item.action),
  );
  console.log(filterByLocalUpdateData);

  const [isBulkSchedulerUpdating, setIsBulkSchedulerUpdating] = useState(false);

  // onsubmit handler
  const bulkSchedulerUpload = () => {
    setIsBulkSchedulerUpdating(true);
    var config = {
      method: "post",
      url: VARIABLES.url + "/api/bulk-scheduler",
      headers: {
        "Content-Type": "application/json",
      },
      data: filterByLocalUpdateData,
    };
    console.log(config);

    axios(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Scheduler updated successfully",
          showConfirmButton: true,
        });
        apiSchedulerData();
        apiAllSchedulerData();
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Failed to update Scheduler",
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setIsBulkSchedulerUpdating(false); // 👈 stop loading (always runs)
      });
  };

  const apiSchedulerData = async () => {
    try {
      const res = await axios.get(
        VARIABLES.url + `/api/scheduler-details?entity_id=${scheduler_id}`,
      );
      // const res = await axios.get(VARIABLES.url + `/api/scheduler-details`);
      setSchedularData(res.data);
      console.log(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const apiAllSchedulerData = async () => {
    try {
      const res = await axios.get(VARIABLES.url + `/api/scheduler-details`);
      console.log(res.data);
      const filterByNode = res.data.filter(
        (data) => data.entity.node_id === scheduler_node_id,
      );
      setNodeSchedulerData(filterByNode);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    lastScheduleIndexRef.current = lastScheduleIndex;
  }, [lastScheduleIndex]);

  useEffect(() => {
    nodeSchedulerDataRef.current = nodeSchedulerData;
  }, [nodeSchedulerData]);

  return (
    <div>
      <StateContext.Provider
        value={{
          tankHandleDetails,
          setTankHandleDetails,
          setLastScheduleIndex,
          lastScheduleIndex,
          lastScheduleIndexRef,

          nodeSchedulerData,
          setNodeSchedulerData,
          bulkSchedulerUpload,

          isBulkSchedulerUpdating,

          schedulerData,
          setSchedularData,
        }}
      >
        {children}
      </StateContext.Provider>
    </div>
  );
}

export default StateContextProvider;
